var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1453 12.1794L10.4935 6.53756C10.4007 6.44397 10.2902 6.36968 10.1685 6.31898C10.0468 6.26829 9.91633 6.24219 9.7845 6.24219C9.65268 6.24219 9.52217 6.26829 9.40048 6.31898C9.2788 6.36968 9.16836 6.44397 9.07553 6.53756C8.88955 6.72465 8.78516 6.97774 8.78516 7.24154C8.78516 7.50535 8.88955 7.75843 9.07553 7.94552L14.0184 12.9383L9.07553 17.8812C8.88955 18.0683 8.78516 18.3213 8.78516 18.5851C8.78516 18.849 8.88955 19.102 9.07553 19.2891C9.16801 19.3835 9.2783 19.4585 9.4 19.51C9.52169 19.5614 9.65239 19.5881 9.7845 19.5887C9.91662 19.5881 10.0473 19.5614 10.169 19.51C10.2907 19.4585 10.401 19.3835 10.4935 19.2891L16.1453 13.6473C16.2467 13.5538 16.3276 13.4403 16.3829 13.314C16.4382 13.1877 16.4668 13.0512 16.4668 12.9133C16.4668 12.7754 16.4382 12.639 16.3829 12.5127C16.3276 12.3864 16.2467 12.2729 16.1453 12.1794Z",
    fill: "#1EA1F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.c62b0aa56cbe5e931e9dfc6c3baf5da5.svg";
export { ForwardRef as ReactComponent };